import LegalEntityBasicData from "./LegalEntityBasicData";

export default LegalEntityBasicData;
